import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'

type Props = {
    open: boolean
    onClose: () => void
}

const DuplicateHolidayDialog: React.FC<Props> = ({ open, onClose }) => {
    const classes = useStyles()
    const translate = useTranslate()

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth classes={{ paper: classes.paper }}>
            <DialogTitle className={classes.header}>
                <Typography variant="h6" className={classes.headerText}>
                    {translate.get('ALERT.TITLE.ERROR')}
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Typography> {translate.get('ALERT.CONTENT.HOLIDAY_EXISTS')}</Typography>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button onClick={onClose} variant="contained" color="primary">
                    {translate.get('BUTTON.CLOSE')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const useStyles = makeStyles((theme) => ({
    paper: {
        overflow: 'hidden',
    },
    header: {
        background: '#DB5F8E',
        padding: theme.spacing(2),
    },
    headerText: {
        color: '#fff',
        fontWeight: 700,
    },
    content: {
        padding: theme.spacing(3),
    },
    actions: {
        padding: theme.spacing(0, 3, 3),
        display: 'flex',
        justifyContent: 'flex-end',
    },
}))

export default DuplicateHolidayDialog
